import React, { useEffect, useRef } from 'react';
import './OnboardingSuccessScreen.css';

export default function OnboardingSuccessScreen({ onDone, durationMs = 3000 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!onDone) return;
    const t = setTimeout(() => onDone(), durationMs);
    return () => clearTimeout(t);
  }, [onDone, durationMs]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext('2d');
    let W = window.innerWidth;
    let H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;

    const maxConfettis = 150;
    const particles = [];
    const possibleColors = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', 
      '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2', 
      '#F8B739', '#52C9AA', '#E74C3C', '#3498DB'
    ];

    function randomFromTo(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from);
    }

    function ConfettiParticle() {
      this.x = Math.random() * W;
      this.y = Math.random() * H - H;
      this.r = randomFromTo(11, 33);
      this.d = Math.random() * maxConfettis + 11;
      this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
      this.tilt = Math.floor(Math.random() * 33) - 11;
      this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
      this.tiltAngle = 0;

      this.draw = function() {
        context.beginPath();
        context.lineWidth = this.r / 2;
        context.strokeStyle = this.color;
        context.moveTo(this.x + this.tilt + this.r / 3, this.y);
        context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
        return context.stroke();
      };
    }

    let animationFrameId;
    let startTime = Date.now();

    function Draw() {
      const elapsed = Date.now() - startTime;
      
      // Stop animation after 3 seconds
      if (elapsed > 3000) {
        context.clearRect(0, 0, W, H);
        cancelAnimationFrame(animationFrameId);
        return;
      }

      animationFrameId = requestAnimationFrame(Draw);
      context.clearRect(0, 0, W, H);

      for (let i = 0; i < maxConfettis; i++) {
        particles[i].draw();
      }

      let particle = {};
      for (let i = 0; i < maxConfettis; i++) {
        particle = particles[i];

        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2;
        particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

        if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
          particle.x = Math.random() * W;
          particle.y = -30;
          particle.tilt = Math.floor(Math.random() * 10) - 20;
        }
      }
    }

    const handleResize = () => {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W;
      canvas.height = H;
    };

    window.addEventListener('resize', handleResize, false);

    // Initialize particles
    for (let i = 0; i < maxConfettis; i++) {
      particles.push(new ConfettiParticle());
    }

    Draw();

    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="obs-root" role="status" aria-live="polite">
      <canvas ref={canvasRef} className="obs-confetti-canvas" />
      
      <div className="obs-card" role="dialog" aria-label="Onboarding successful">
        <div className="obs-title">Onboarding Successful</div>
        <div className="obs-subtitle">Taking you to your dashboard…</div>
      </div>
    </div>
  );
}
